import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { FreehandCropper } from "../../Utilities/Croppers";
import "../../../Assets/css/kyc.css";
import { Button } from "@mui/material";

const resizeImage = (imageFile, width) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const scaleFactor = width / img.width;
      canvas.width = width;
      canvas.height = img.height * scaleFactor;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg"));
    };
    img.src = URL.createObjectURL(imageFile);
  });
};

const handleBlobUpload = async (base64Data, side) => {
  try {
    const byteString = atob(base64Data.split(",")[1]);
    const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uintArray[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });

    const formData = new FormData();
    formData.append("file", blob, `${side}.jpeg`);

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data.url;
  } catch (error) {
    console.error("Error uploading file:", error.message);
  }
};

function OcrPassport() {
  const [openCropper, setOpenCropper] = useState({ front: false, back: false });
  const [selectedImages, setSelectedImages] = useState({ front: "", back: "" });
  const [croppedImages, setCroppedImages] = useState({ front: "", back: "" });
  const [blobUrls, setBlobUrls] = useState({ front: "", back: "" });
  const [passportData, setPassportData] = useState({});

  const [storedImages, setStoredImages] = useState({ front: "", back: "" });

  const [isUploading, setIsUploading] = useState(false);

  const frontImageRef = useRef(null);
  const backImageRef = useRef(null);

  const getImages = async () => {
    try {
      const images = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/ocr/images`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
        }
      );
      // get array of objects with document_type === "passport"
      const front = images.data.data.filter(
        (image) => image.document_type === "Passport_Front"
      );
      const back = images.data.data.filter(
        (image) => image.document_type === "Passport_Back"
      );
      setStoredImages({ front: front[0].blob_url, back: back[0].blob_url });
      getPassportData(front[0].blob_url, back[0].blob_url);
    } catch (error) {
      console.error("Error getting images:", error.message);
    }
  };

  const getPassportData = async (front, back) => {
    try {
      const ocrResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/ocr/passport`,
        {
          front,
          back,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
        }
      );

      setPassportData(ocrResponse.data.data);
    } catch (error) {
      console.error("Error uploading file:", error.message);
    }
  };

  useEffect(() => {
    getImages();
  }, []);

  const handleUpload = async () => {
    try {
      setIsUploading(true);
      const front = resizeImage(croppedImages.front, 512);
      const back = resizeImage(croppedImages.back, 512);

      Promise.all([front, back]).then((values) => {
        const frontUrl = values[0];
        const backUrl = values[1];

        Promise.all([
          handleBlobUpload(frontUrl, "front"),
          handleBlobUpload(backUrl, "back"),
        ]).then((urls) => {
          setBlobUrls({ front: urls[0], back: urls[1] });
          console.log(urls);
        });
      });

      const ocrResponse = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/ocr/passport`,
        {
          front: blobUrls.front,
          back: blobUrls.back,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
        }
      );

      setPassportData(ocrResponse.data.data);
      setSelectedImages({ front: "", back: "" }); // reset selected images
      setCroppedImages({ front: "", back: "" }); // reset cropped images
      setIsUploading(false);
    } catch (error) {
      console.error("Error uploading file:", error.message);
      setIsUploading(false);
    }
  };

  return (
    <div className="Allcards_full_container p-3">
      <div className="min-vh-100 rounded-2 bg-white p-2">
        <h1 className="text-center">Passport Verification</h1>

        {!storedImages.front && !storedImages.back && (
          <div
            style={{
              marginTop: "20px",
              width: "100%",
              display: "flex",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <div id="front" className="uploadZone" style={{ padding: "5px" }}>
              {croppedImages.front ? (
                <div
                  style={{
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    style={{
                      objectFit: "contain",
                      objectPosition: "center",
                      width: "280px",
                    }}
                    src={URL.createObjectURL(croppedImages.front)}
                    alt="Passport Front"
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    frontImageRef.current.click();
                  }}
                  style={{
                    cursor: "pointer",
                    minHeight: "200px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Passport Front Page <br /> Click to Upload
                  <input
                    ref={frontImageRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      if (e.target.files[0].type.startsWith("image")) {
                        setSelectedImages({
                          ...selectedImages,
                          front: e.target.files[0],
                        });
                        setOpenCropper({ ...openCropper, front: true });
                        console.log(e.target.files[0]);
                      } else {
                        return;
                      }
                    }}
                  />
                </div>
              )}
            </div>

            <div id="back" className="uploadZone" style={{ padding: "5px" }}>
              {croppedImages.back ? (
                <div
                  style={{
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    style={{
                      objectFit: "contain",
                      objectPosition: "center",
                      width: "280px",
                    }}
                    src={URL.createObjectURL(croppedImages.back)}
                    alt="Passport Back"
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    backImageRef.current.click();
                  }}
                  style={{
                    cursor: "pointer",
                    minHeight: "200px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Passport Last Page <br /> Click to Upload
                  <input
                    ref={backImageRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      if (e.target.files[0].type.startsWith("image")) {
                        setSelectedImages({
                          ...selectedImages,
                          back: e.target.files[0],
                        });
                        setOpenCropper({ ...openCropper, back: true });
                        console.log(e.target.files[0]);
                      } else {
                        return;
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {!storedImages.front &&
          !storedImages.back &&
          croppedImages.front &&
          croppedImages.back && (
            <div
              style={{
                margin: "0px auto",
                marginBottom: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                width: "300px",
              }}
            >
              <Button
                variant="contained"
                color="error"
                sx={{ width: "100%" }}
                onClick={() => {
                  setSelectedImages({ front: "", back: "" });
                  setCroppedImages({ front: "", back: "" });
                }}
              >
                Reset
              </Button>
              <Button
                variant="contained"
                sx={{ width: "100%" }}
                onClick={handleUpload}
                disabled={isUploading}
              >
                {isUploading ? "Uploading..." : "Upload"}
              </Button>
            </div>
          )}

        {storedImages.front && storedImages.back && (
          <div
            style={{
              marginTop: "20px",
              width: "100%",
              display: "flex",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <div id="front" className="uploadZone" style={{ padding: "5px" }}>
              <img
                style={{
                  objectFit: "contain",
                  objectPosition: "center",
                  width: "280px",
                }}
                src={storedImages.front}
                alt="Passport Front"
              />
            </div>

            <div id="back" className="uploadZone" style={{ padding: "5px" }}>
              <img
                style={{
                  objectFit: "contain",
                  objectPosition: "center",
                  width: "280px",
                }}
                src={storedImages.back}
                alt="Passport Back"
              />
            </div>
          </div>
        )}

        {passportData.id && (
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "20px",
              justifyContent: "center",
            }}
          >
            <div
              style={{ width: "400px", padding: "10px", border: "2px solid" }}
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "10px",
                  fontWeight: "900",
                }}
              >
                REPUBLIC OF INDIA
              </h3>
              <p
                style={{
                  margin: 0,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "10px",
                }}
              >
                <MyTextBox type="Type" content={passportData.type} />
                <MyTextBox
                  type="Country Code"
                  content={passportData.country_code}
                />
                <MyTextBox
                  type="Passport No."
                  content={passportData.passport_no}
                />
              </p>
              <MyTextBox
                type="Surname"
                content={passportData.surname}
                align="left"
              />
              <MyTextBox
                type="Given Name"
                content={passportData.given_name}
                align="left"
              />
              <p
                style={{
                  margin: 0,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "10px",
                }}
              >
                <MyTextBox
                  type="Nationality"
                  content={passportData.nationality}
                />
                <MyTextBox type="Gender" content={passportData.gender} />
                <MyTextBox type="Date of Birth" content={passportData.dob} />
              </p>
              <MyTextBox
                type="Place of Birth"
                content={passportData.birth_place}
                align="left"
              />
              <MyTextBox
                type="Place of Issue"
                content={passportData.issue_place}
                align="left"
              />
              <p
                style={{
                  margin: 0,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                }}
              >
                <MyTextBox
                  type="Date of Issue"
                  content={passportData.doi}
                  align="left"
                />
                <MyTextBox
                  type="Date of Expiry"
                  content={passportData.doe}
                  align="left"
                />
              </p>
              <pre style={{ margin: 0 }}>
                {passportData.passport_mrz_line1}
                <br />
                {passportData.passport_mrz_line2}
              </pre>
            </div>

            <div
              style={{ width: "400px", padding: "10px", border: "2px solid" }}
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "10px",
                  fontWeight: "900",
                }}
              >
                REPUBLIC OF INDIA
              </h3>
              <MyTextBox
                type={"Father Name/ Legal Guardian"}
                content={passportData.legal_guardian}
                align="left"
              />
              <MyTextBox
                type={"Mother Name"}
                content={passportData.mother_name}
                align="left"
              />
              <MyTextBox
                type={"Spouse Name"}
                content={passportData.spouce}
                align="left"
              />
              <MyTextBox
                type={"Address"}
                content={passportData.address.split(", ")[0]}
                align="left"
              />
              <MyTextBox
                content={passportData.address.split(", ")[1]}
                align="left"
              />
              <MyTextBox
                content={passportData.address.split(", ")[2]}
                align="left"
              />
              <div
                style={{ display: "grid", gridTemplateColumns: "1fr 1fr  1fr" }}
              >
                <MyTextBox
                  type={"Old Passport No."}
                  content={passportData.old_number}
                />
                <MyTextBox
                  type={"Old Date of Issue"}
                  content={passportData.old_doi}
                />
                <MyTextBox
                  type={"Old Place of Issue"}
                  content={passportData.old_poi}
                />
              </div>
              <MyTextBox
                type={"File No."}
                content={passportData.file_no}
                align="left"
              />
            </div>
          </div>
        )}

        {selectedImages.front && (
          <FreehandCropper
            autoCrop={false}
            open={openCropper.front}
            file={selectedImages.front}
            selectedImage={URL.createObjectURL(selectedImages.front)}
            onClose={() => {
              setOpenCropper({ ...openCropper, front: false });
            }}
            onSave={(cropped_image) => {
              setCroppedImages({ ...croppedImages, front: cropped_image });
            }}
          />
        )}

        {selectedImages.back && (
          <FreehandCropper
            autoCrop={false}
            open={openCropper.back}
            file={selectedImages.back}
            selectedImage={URL.createObjectURL(selectedImages.back)}
            onClose={() => {
              setOpenCropper({ ...openCropper, back: false });
            }}
            onSave={(cropped_image) => {
              setCroppedImages({ ...croppedImages, back: cropped_image });
            }}
          />
        )}
      </div>
    </div>
  );
}

export default OcrPassport;

const MyTextBox = ({ type, content, align = "center" }) => {
  return (
    <div>
      <p
        style={{
          margin: 0,
          padding: 0,
          color: "gray",
          fontSize: "8px",
          textAlign: align,
        }}
      >
        {type}
      </p>
      <p
        style={{
          margin: 0,
          padding: 0,
          fontWeight: "bold",
          textAlign: align,
          fontSize: "14px",
        }}
      >
        {content}
      </p>
      <hr style={{ margin: 0, padding: 0 }} />
    </div>
  );
};
